import { POSTWithAuth } from './Index'

import { SaveUserEmailRequest, SaveUserEmailResponse } from '../interfaces/SaveUserEmail'

export async function SaveUserEmail(
  user: string,
  request: SaveUserEmailRequest
): Promise<SaveUserEmailResponse> {
  return await POSTWithAuth<SaveUserEmailRequest, SaveUserEmailResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${user}/setEmail`,
    request
  )
}
